import { useNavigate } from "react-router-dom";
import { Rating } from "./Rating";
import { Check, Phone, Mail, MessageCircle } from "lucide-react";

export const AgentCard = ({ agentData }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
      {/* Agency Header */}
      <div
        className={`py-3 text-center ${agentData?.primary_color ? "" : "bg-black"}`}
        style={agentData?.primary_color ? { backgroundColor: agentData.primary_color } : undefined}
      >
        <img
          src={agentData?.agencyLogo}
          alt="Agency"
          className="h-8 mx-auto object-contain"
        />
      </div>

      {/* Profile Section */}
      <div className="p-6 text-center">
        <div className="relative w-[120px] h-[120px] mx-auto">
          <img
            src={agentData?.profileImg}
            alt="Agent"
            className="w-full h-full rounded-full object-cover border-4 border-gray-200 bg-white"
          />

          <div className="absolute bottom-2 right-2 bg-[#1E88E5] w-6 h-6 rounded-full flex items-center justify-center border-2 border-white shadow-md">
            <Check size={14} strokeWidth={3} color="white" />
          </div>
        </div>

        <h3 className="font-bold text-xl text-[#171717] mt-5">
          {agentData?.name}
        </h3>

        <div className="flex-col justify-center items-center mt-5">
          <Rating rating={agentData?.average} size={25} />
          <div className="text-base font-medium text-gray-700 mt-4">
            {agentData?.reviewCount || 0} reviews
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-6 space-y-4">
          {/* Call Agent */}
          <a
            href={`tel:${agentData?.phone}`}
            className="flex items-center justify-center gap-3 w-full bg-[#097FE6] text-white py-4 rounded-full font-semibold text-base hover:bg-[#0866c2] transition"
          >
            <Phone size={18} strokeWidth={2.5} />
            <span>Call Agent</span>
          </a>

          {/* Email */}
          <button
            onClick={() => navigate(`/agent-profile/${agentData?.id}`)}
            className="flex items-center justify-center gap-3 w-full bg-gray-100 text-gray-800 py-4 rounded-full font-semibold text-base border border-gray-200 hover:bg-gray-200 transition"
          >
            <Mail size={18} strokeWidth={2.5} />
            <span>Email</span>
          </button>

          {/* Whatsapp */}
          <a
            href={`https://wa.me/${agentData?.phone}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 w-full bg-[#25D366] text-white py-4 rounded-full font-semibold text-base hover:bg-[#1ebe5d] transition"
          >
            <MessageCircle size={18} strokeWidth={2.5} />
            <span>Whatsapp</span>
          </a>
        </div>
      </div>
    </div>
  );
};
